import React from 'react';
import {Box} from 'reactjs-admin-lte';
import FontAwsome from 'react-fontawesome';
import {Col, Row} from 'react-bootstrap';

export default ({loading = true, car_info = {}}) => {
  return (<div>
        <Box loading={loading}>
          <Box.Header>
            <Box.Title border={true}>
              <FontAwsome className="text-blue"
                          name="car" /> รายละเอียดรถยนต์
            </Box.Title>
          </Box.Header>
          <Box.Body>

            {/*Row 1*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">ทะเบียนรถ</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.car_registration_no} />
              </Col>
              <Col sm={2}>
                <label className="control-label">จังหวัด</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.province} />
              </Col>
            </Row>

            {/*Row 2*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">ประเภทรถ</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.car_type} />
              </Col>
              <Col sm={2}>
                <label className="control-label">ยี่ห้อ</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.brand} />
              </Col>
            </Row>

            {/*Row 3*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">รุ่น</label>
              </Col>
              <Col sm={2}>
                <input className="form-control" disabled
                       value={car_info.model} />
              </Col>
              <Col sm={2}>
                <div className="input-group">
                  <div className="input-group-addon"
                       style={{border: 'none', fontSize: 16}}>
                    <label className="control-label">ปี</label>
                  </div>

                  <input className="form-control" disabled
                         value={car_info.year} />

                </div>
              </Col>
              <Col sm={2}>
                <label className="control-label">โฉม</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.series} />
              </Col>
            </Row>


            {/*Row 4*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">หมายเลขตัวถัง/โมเดล</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.chassis_no} />
              </Col>
              <Col sm={2}>
                <label className="control-label">หมายเลขเครื่อง</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.engine_no} />
              </Col>
            </Row>


            {/*Row 5*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">หมายเลข กม.</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.mileage} />
              </Col>
              <Col sm={2}>
                <label className="control-label">สภาพรถ</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.damage} />
              </Col>
            </Row>


            {/*Row 6*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">สีรถ</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.car_color} />
              </Col>
              <Col sm={2}>
                <label className="control-label">สีที่พ่น</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.paint_type} />
              </Col>
            </Row>


            {/*Row 7*/}
            <Row className="form-group">
              <Col sm={2}>
                <label
                    className="control-label">รถประกัน,รถคู่กรณี,เงินสด</label>
              </Col>
              <Col sm={2}>
                <input className="form-control" disabled
                       value={car_info.accident_type} />
              </Col>
              <Col sm={2}>
                <div className="input-group">
                  <div className="input-group-addon"
                       style={{border: 'none', fontSize: 16}}>
                    <strong>คันที่</strong>
                  </div>
                  <input className="form-control" disabled
                         value={car_info.car_at} />
                </div>
              </Col>
              <Col sm={2}>
                <label className="control-label">เบอร์รถ(ถ้ามี)</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.car_no} />
              </Col>
            </Row>

          </Box.Body>
        </Box>


        <Box loading={loading}>
          <Box.Header>
            <Box.Title border={true}>
              <FontAwsome className="text-blue"
                          name="user" /> รายละเอียดค่าส่วนต่าง
            </Box.Title>
          </Box.Header>
          <Box.Body>

            {/*Row 1*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">ค่าเสียหายส่วนแรก
                                                 (Excess)</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.excess} />
              </Col>
            </Row>

            {/*Row 2*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">ค่าส่วนต่าง 50% (ถ้ามี)</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info['50discount']} />
              </Col>
            </Row>

            {/*Row 3*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">ค่าส่วนต่างลูกค้าจ่ายเพิ่ม
                                                 (ถ้ามี)</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.diff_payment} />
              </Col>
            </Row>

            {/*Row 4*/}
            <Row className="form-group">
              <Col sm={2}>
                <label className="control-label">รวมค่าส่วนต่าง</label>
              </Col>
              <Col sm={4}>
                <input className="form-control" disabled
                       value={car_info.sum_excess} />
              </Col>
            </Row>

          </Box.Body>
        </Box>
      </div>
  );
};


// WEBPACK FOOTER //
// ./src/view/workdoc/preview/components/PreviewCar.js